/*=========================================================================================
  File Name: moduleAuth.js
  Description: Auth Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleStorehouseState.js'
import mutations from './moduleStorehouseMutations.js'
import actions from './moduleStorehouseActions.js'
import getters from './moduleStorehouseGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
